import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CloseIcon from '@mui/icons-material/Close';
import backgroundImage from '../../images/videobackground1.jpg'; // Replace with your image path

function Secthree() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const handlePlayButtonClick = () => {
    setIsVideoOpen(true);
  };

  const handleCloseButtonClick = () => {
    setIsVideoOpen(false);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '500px', // Adjust as needed for the height
        backgroundImage: `url(${backgroundImage})`, // Use imported image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Play Button */}
      {!isVideoOpen && (
        <IconButton
          onClick={handlePlayButtonClick}
          sx={{
            color: 'white',
            fontSize: '4rem',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            borderRadius: '50%',
            padding: 3,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
          }}
        >
          <PlayCircleIcon sx={{ fontSize: '4rem' }} />
        </IconButton>
      )}

      {/* Video Iframe */}
      {isVideoOpen && (
        <Box
          sx={{ 
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: 10,
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleCloseButtonClick}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
              },
            }}
          >
            <CloseIcon sx={{ fontSize: '2rem' }} />
          </IconButton>

          {/* YouTube Video */}
          <iframe
            width="80%"
            height="80%"
            src="https://www.youtube.com/embed/3arRLsEbSHE?si=jPWbIgYrDc-QZ5zo"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>
      )}
    </Box>
  );
}

export default Secthree;
